import { Injectable, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IGeneralMessage } from '../../../../model/general-message';
import { GeneralMessageDialogComponent } from './general-message-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class GeneralMessageService {
    constructor(public dialog: MatDialog, private readonly snackBar: MatSnackBar, private readonly zone: NgZone) {}

    showDialog(generalMessage: IGeneralMessage) {
        this.dialog.open(GeneralMessageDialogComponent, {
            data: generalMessage,
            disableClose: true,
            closeOnNavigation: false,
            hasBackdrop: true
        });
    }

    showSnackBar(generalMessage: IGeneralMessage, cssClasses: string[] = [], closable = true) {
        this.zone.run(() => {
            this.snackBar.open(`${generalMessage.title}: ${generalMessage.message}`, closable ? 'Close' : '', {
                panelClass: cssClasses,
                horizontalPosition: 'center',
                verticalPosition: 'bottom'
            });
        });
    }

    showInfoSnackBar(generalMessage: IGeneralMessage) {
        this.showSnackBar(generalMessage, ['snackBar', 'info']);
    }

    showErrorSnackBar(generalMessage: IGeneralMessage, closable = true) {
        this.showSnackBar(generalMessage, ['snackBar', 'error'], closable);
    }

    closeOpenSnackBar() {
        this.snackBar?._openedSnackBarRef?.dismiss();
    }
}
